<app-common-offcanvas [opened]="opened()" (close)="closeOffcanvas()">
  <div class="header">
    <app-offcanvas-pagination-title
      [title]="textMessageRecord?.header ?? null"
      [currentIndex]="currentEmailMessageIndex"
      [total]="totalRows"
      [isControlsDisabled]="isMessageActionLoading || isOuterLoading"
      (moveToPrevious)="openPreviousEmail()"
      (moveToNext)="openNextEmail()"
    />
  </div>

  @if (textMessageRecord && !isOuterLoading) {
    <div class="content-wrapper">
      <div class="content">
        @if (textMessageRecord.errorMessage) {
          <div class="error-message-wrapper">
            <app-disclaimer color="red" icon="ic-cancel-circle-20">
              {{ textMessageRecord.errorMessage }}
            </app-disclaimer>
          </div>
        }
        <div class="email-date-status">
          <div>
            <div class="title">Date & Time</div>
            <div class="text-gray900 font-weight-bold">
              {{ textMessageRecord.createdOn | date : 'dd MMM yyyy HH:mm' : 'en-US' }}
            </div>
          </div>

          <div>
            <div class="title">Status</div>
            <div>
              <app-ag-outgoing-text-message-status [status]="textMessageRecord.status"/>
            </div>
          </div>
        </div>

        <ul class="recipients-list list-unstyled mb-0">
          @if (textMessageRecord.to) {
            <li class="recipients-group">
              <div class="recipients-type">To:</div>
              <div class="recipients-addresses">{{ textMessageRecord.to }}</div>
            </li>
          }
        </ul>

        <div class="email-preview-wrapper">
          @if (isTextMessageModelLoading) {
            <div class="text-message-content loader">
              <ngx-skeleton-loader style="width: 100%" count="4" appearance="line"/>
            </div>
          } @else if (textMessageModel?.message) {
            <div class="text-message-content" [innerHtml]="textMessageModel?.message"></div>
          }
        </div>
      </div>

      <div class="controls">
        @if (resentEmailDate) {
          <div>
            <div class="title">Email was resent on</div>
            <div>
              {{ resentEmailDate | date : 'dd MMM yyyy HH:mm' : 'en-US' }}
            </div>
          </div>
        }

        @if (textMessageRecord.status === TextMessageStatus.Failed) {
          <button
            *appHasRole="['Admin']"
            class="btn btn-primary d-flex align-items-center gap-2"
            [disabled]="isMessageActionLoading"
            (click)="resendEmail()"
          >
            <i class="icon ic-sent-mail-20"></i>
            <span>Resend</span>
          </button>
        }

        <button
          *appHasRole="['Admin']"
          class="btn btn-secondary d-flex align-items-center gap-2"
          [disabled]="isMessageActionLoading"
          (click)="deleteEmail()"
        >
          <i class="icon ic-trash-20"></i>
          <span>Delete</span>
        </button>
      </div>
    </div>
  } @else if (isOuterLoading) {
    <app-loader minHeight="200"/>
  }
</app-common-offcanvas>
